import logErrors from '@nykaa/logger/logErrors';
import { setBadge } from '@nykaa/user-experience/badgingApi';
import { ApiHelper } from 'shared/api';
import { ROUTES, getUrl } from 'shared/api/urls';
import { standardErrorMessages } from 'shared/constants';
import { platformNames } from 'shared/constants';

import {
  ADD_TO_CART_REQUEST_PATH,
  ADD_TO_CART_REFRESH_REQUEST_PATH,
} from './constants';
import { transformAddToCart } from './transformers';
import { State } from 'store/types';
import { getPageName, getEddPinCode } from './helpers';
import { BulkAddToCartParams } from './action';

export const getConvenienceFeeHeader = (
  enabled?: boolean
): { [key: string]: string } =>
  enabled ? { 'X-APPLY-CART-CHARGES': 'true' } : {};

export const addToCart = async (
  params: any,
  state: State,
  isCartAndRefresh = false,
  convenienceChargesEnabled?: boolean
) => {
  let otherData = {};
  let header = {};
  const { trackingParam = {} } = params || {};
  let navTracking = {};
  const { site_navigation = '', site_sub_navigation = '' } =
    trackingParam || {};
  const { siteNavigation = '', siteSubNavigation = '' } =
    state?.dataLayer || {};
  navTracking = {
    site_navigation: site_navigation || siteNavigation,
    site_sub_navigation: site_sub_navigation || siteSubNavigation,
  };
  if (state) {
    const isEddWidget = state?.remoteConfig?.switches?.eddWidget;
    if (isEddWidget) {
      otherData = {
        originSource: getPageName(state?.appReducer?.pageType),
        ...getEddPinCode(),
      };
      header = {
        'X-SERVICEABLE': 'true',
        ...getConvenienceFeeHeader(
          isCartAndRefresh && convenienceChargesEnabled
        ),
      };
    }
  }
  const isBadgingApiEnabled = state?.remoteConfig?.switches?.badgingApiEnabled;

  const url = isCartAndRefresh
    ? `${getUrl(ROUTES.GATEWAY)}${ADD_TO_CART_REFRESH_REQUEST_PATH}`
    : `${getUrl(ROUTES.GATEWAY)}${ADD_TO_CART_REQUEST_PATH}`;

  const postData = {
    deviceType: 'MSITE',
    domain: __PLATFORM__,
    items: [
      {
        productId: params.productId,
        quantity: 1,
      },
    ],
    pro: !!params.isPro,
    trackingParam: { ...trackingParam, ...navTracking },
    ...otherData,
    buyNow: params?.buyNow || false,
  };

  let catalogParams = {};
  if (__PLATFORM__ === platformNames.MEN) {
    catalogParams = { catalog_tag_filter: __PLATFORM__ };
  }
  try {
    const {
      data: { success, data: apiData, message },
    } = await ApiHelper(
      `${url}`,
      'post',
      { ...postData, ...catalogParams },
      header
    );

    if (!success) {
      return Promise.reject({
        errorInApi: true,
        message: message || standardErrorMessages.SOMETHING_WRONG,
      });
    }

    const cartData = transformAddToCart(apiData);
    if (isBadgingApiEnabled) setBadge(cartData?.itemsQuantity);
    return cartData;
  } catch (e) {
    const customMessage = 'Error in add to cart api';
    logErrors(e, customMessage);
    throw e;
  }
};

export const bulkAddToCart = async (
  params: BulkAddToCartParams,
  state: State,
  isCartAndRefresh = false,
  convenienceChargesEnabled?: boolean
) => {
  let otherData = {};
  let header = {};
  const { trackingParam, items } = params || {};
  let navTracking = {};
  const { site_navigation = '', site_sub_navigation = '' } =
    trackingParam || {};
  const { siteNavigation = '', siteSubNavigation = '' } =
    state?.dataLayer || {};
  navTracking = {
    site_navigation: site_navigation || siteNavigation,
    site_sub_navigation: site_sub_navigation || siteSubNavigation,
  };
  if (state) {
    const isEddWidget = state?.remoteConfig?.switches?.eddWidget;
    if (isEddWidget) {
      otherData = {
        originSource: getPageName(state?.appReducer?.pageType || ''),
        ...getEddPinCode(),
      };
      header = {
        'X-SERVICEABLE': 'true',
        ...getConvenienceFeeHeader(
          isCartAndRefresh && convenienceChargesEnabled
        ),
      };
    }
  }
  const isBadgingApiEnabled = state?.remoteConfig?.switches?.badgingApiEnabled;

  const url = isCartAndRefresh
    ? `${getUrl(ROUTES.GATEWAY)}${ADD_TO_CART_REFRESH_REQUEST_PATH}`
    : `${getUrl(ROUTES.GATEWAY)}${ADD_TO_CART_REQUEST_PATH}`;

  const postData = {
    deviceType: 'MSITE',
    domain: __PLATFORM__,
    items: items,
    pro: !!params.isPro,
    trackingParam: { ...trackingParam, ...navTracking },
    ...otherData,
  };

  let catalogParams = {};
  if (__PLATFORM__ === platformNames.MEN) {
    catalogParams = { catalog_tag_filter: __PLATFORM__ };
  }
  try {
    const {
      data: { success, data: apiData, message },
    } = await ApiHelper(
      `${url}`,
      'post',
      { ...postData, ...catalogParams },
      header
    );

    if (!success) {
      return Promise.reject({
        errorInApi: true,
        message: message || standardErrorMessages.SOMETHING_WRONG,
      });
    }

    const cartData = transformAddToCart(apiData);
    if (isBadgingApiEnabled) setBadge(cartData?.itemsQuantity);
    return cartData;
  } catch (e: any) {
    const customMessage = 'Error in add to cart api';
    logErrors(e, customMessage);
    throw e;
  }
};
